/**
 * Tally feedback popup, loaded on demand - the embed script is only fetched
 * when someone actually opens feedback, never on page view.
 */
export function openFeedback() {
  const open = () =>
    window.Tally?.openPopup('xXd7Gv', { overlay: true, emoji: { text: '👋', animation: 'wave' } })

  if (window.Tally) {
    setTimeout(open, 150)
    return
  }
  const script = document.createElement('script')
  script.src = 'https://tally.so/widgets/embed.js'
  script.async = true
  script.onload = () => setTimeout(open, 150)
  document.body.appendChild(script)
}
